import './CTA.css'

export function CTA() {
  return (
    <section className="cta">
      <div className="cta__divider">
        {'━'.repeat(119)}
      </div>
      <div className="cta__content">
        <div className="cta__item">
          <span className="cta__tag">Join Waitlist</span>
          <a href="https://discord.gg/zqr9Pty8kf" className="cta__link">[<span className="cta__link-text">Click Here!</span>]</a>
        </div>
      </div>
    </section>
  )
}
